
import { ResultData } from "@nt-portal/common-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { TCMScheduleStatus, TCMScheduleStatusService } from "@nt-portal/tcm-sdk";
import { ValidateResult } from "@nt-portal/common-sdk";

export interface TCMScheduleStatusOptions extends ControllerOptions<TCMScheduleStatus> {

}


export const initTCMScheduleStatus = (inObj: Partial<TCMScheduleStatus>): TCMScheduleStatus => {
    let item: TCMScheduleStatus = {
        color: inObj.color ?? "000000",
        description: inObj.description ?? "",
        name: inObj.name ?? "",
        value: inObj.value ?? "",
        createdBy: ""
    }
    return item;
}


export class ClientTCMScheduleStatusService extends BaseClientService implements DataController<TCMScheduleStatus> {

    private _service: TCMScheduleStatusService;


    constructor() {
        super();
        this._service = new TCMScheduleStatusService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public async get(options: TCMScheduleStatusOptions): Promise<ResultData<TCMScheduleStatus>> {

        return await this._service.get(this.buildFetchParams(options), this.token, options.filter);

    }
    public async getLookup(options: TCMScheduleStatusOptions): Promise<ResultData<TCMScheduleStatus>> {
        let fetchParams = this.buildLookupFetchParams(options);
        let data = await this._service.get(fetchParams, this.token);
        return data;
    }

    public async getById(options: TCMScheduleStatusOptions): Promise<TCMScheduleStatus | null> {
        if (options.id) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMScheduleStatusOptions): Promise<any> {
        if (options.id)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMScheduleStatusOptions): Promise<TCMScheduleStatus | TCMScheduleStatus[] | null> {
        if (options.item && options.item.id)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMScheduleStatusOptions): Promise<TCMScheduleStatus | TCMScheduleStatus[] | null> {
        if (options.item)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async validateName(name: string, id?: string): Promise<ValidateResult> {
        return await this._service.validateName(name, this.token, id)
    }

    public async import(options: TCMScheduleStatusOptions): Promise<any> {
        if (options.file)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMScheduleStatusOptions): Promise<any> {
        let fetchParams = this.buildLookupFetchParams(options);
        return await this._service.export(this.token, fetchParams, options.filter);
    }

}